// Polski — mirrors en.js key for key. pl uses the CLDR categories
// one/few/many (other for fractions); the plural strings below carry all of
// them.
const pl = {
  // ===== shared =====
  'common.createPlan': 'Utwórz plan',
  'common.save': 'Zapisz',
  'common.cancel': 'Anuluj',
  'common.delete': 'Usuń',
  'common.edit': 'Edytuj',
  'common.retry': 'Ponów próbę',
  'common.activate': 'Aktywuj',
  'common.deactivate': 'Dezaktywuj',
  'common.enabled': 'Włączono',
  'common.disabled': 'Wyłączono',
  'common.viewTerms': 'Zobacz warunki',
  'common.untitledPlan': 'Plan bez nazwy',
  'common.savedToast': 'Pomyślnie zapisano',

  // ===== nav / chrome =====
  'nav.home': 'Strona główna',
  'nav.plans': 'Plany',
  'nav.settings': 'Ustawienia',

  'mismatch.title': 'Niezgodność środowiska wdrożenia',
  'mismatch.body': 'Ta kompilacja frontendu odwołuje się do {apiBase}, ale jest serwowana z {hostname} (oczekiwano: {expected}).',
  'mismatch.contact': 'Skontaktuj się z pomocą techniczną — to błąd konfiguracji wdrożenia, nie problem z Twoim kontem.',

  'install.title': 'Nie można połączyć się z Shopify',
  'install.body': 'Sprawdź, czy backend działa, a jego SHOPIFY_API_KEY zgadza się z client_id aplikacji w shopify.app.toml.',
  'install.retry': 'Ponów próbę',

  'chrome.loadingBrand': 'Ładowanie FlexCover…',
  'error.title': 'Coś poszło nie tak',
  'error.reload': 'Odśwież',

  'support.badge': 'Widok wsparcia',
  'support.shopUnknown': '(nieznany sklep)',
  'support.expired': 'Token wygasł — wygeneruj nowy w konsoli wsparcia',
  'support.validUntil': 'Token ważny do {time}',
  'support.exit': 'Zakończ',

  // ===== Home =====
  'home.title': 'Witamy w FlexCover: Protection Plans 👋',
  'home.last30days': 'Ostatnie 30 dni',
  'home.loadingChart': 'Ładowanie wykresu',
  'home.loadingOverview': 'Ładowanie przeglądu',
  'home.statOrders': 'Zamówienia z planami',
  'home.statRevenue': 'Łączny przychód z planów',
  'home.gettingStarted': 'Pierwsze kroki',
  'home.allSet': 'Wszystko gotowe 🎉',
  'home.completed': 'Ukończono {done} z {total}',
  'home.step1.title': 'Utwórz swój pierwszy plan',
  'home.step1.desc': 'Ustaw cenę, zakres ochrony i wygląd w koszyku dla swojej oferty ochrony.',
  'home.step2.title': 'Włącz blok aplikacji',
  'home.step2.desc': 'Włącz blok FlexCover: Protection Plans, aby widżet pojawił się w koszyku.',
  'home.step2.enable': 'Włącz blok aplikacji',
  'home.step2.check': 'Sprawdź stan',
  'home.step3.title': 'Zdobądź pierwsze chronione zamówienie',
  'home.step3.desc': 'Gdy widżet będzie aktywny, klienci dodadzą plan w koszyku — sumy pojawią się na kartach powyżej.',
  'home.appEmbed': 'Blok aplikacji',
  'home.checkingEmbed': 'Sprawdzanie stanu bloku aplikacji',
  'home.embedEnabledBody': 'Widżet ochrony jest aktywny w Twojej witrynie.',
  'home.embedTheme': '(motyw: {theme})',
  'home.embedDisabledBody': 'Aplikacja nie jest obecnie aktywna w Twojej witrynie.',
  'home.embedUnknown': 'Nieznany',
  'home.embedUnknownBody': 'Stan witryny będzie dostępny, gdy aplikacja zostanie połączona ze sklepem.',
  'home.embedUnknownReason': 'Nie udało się teraz odczytać Twojego aktywnego motywu.',
  'home.enableEmbedHint': 'W panelu administracyjnym Shopify przejdź do Online Store → Themes → Customize → App embeds i włącz FlexCover: Protection Plans.',
  'home.learnMorePrefix': 'Dowiedz się więcej o ',
  'home.learnMoreLink': 'korzystaniu z planów ochrony',

  // ===== Plans list =====
  'plans.title': 'Plany',
  'plans.loading': 'Ładowanie planów',
  'plans.errorTitle': 'Nie udało się załadować planów',
  'plans.empty.heading': 'Utwórz swój pierwszy plan ochrony',
  'plans.empty.body': 'Oferuj ochronę przesyłki, przedłużone gwarancje, ubezpieczenie zwrotu i własne pokrycie — wszystko z cenami ustalonymi przez Ciebie.',
  'plans.loadDemo': 'Załaduj plany demonstracyjne',
  'plans.demoLoaded': 'Plany demonstracyjne załadowano',
  'plans.demoFailed': 'Nie udało się załadować planów demonstracyjnych: {message}',
  'plans.filterPlaceholder': 'Filtruj plany',
  'plans.addFilter': 'Dodaj filtr',
  'plans.statusHeading': 'Stan',
  'plans.typeHeading': 'Rodzaj ochrony',
  'plans.statusActive': 'Aktywny',
  'plans.statusInactive': 'Nieaktywny',
  'plans.showing_one': 'Wyświetlano {count} plan',
  'plans.showing_few': 'Wyświetlano {count} plany',
  'plans.showing_many': 'Wyświetlano {count} planów',
  'plans.showing_other': 'Wyświetlano {count} planu',
  'plans.sortBy': 'Sortuj według',
  'plans.selectAll': 'Zaznacz wszystkie plany',
  'plans.selectedCount': 'Zaznaczono: {count}',
  'plans.bulkDeleted_one': 'Usunięto {count} plan',
  'plans.bulkDeleted_few': 'Usunięto {count} plany',
  'plans.bulkDeleted_many': 'Usunięto {count} planów',
  'plans.bulkDeleted_other': 'Usunięto {count} planu',
  'plans.bulkActivated_one': 'Aktywowano {count} plan',
  'plans.bulkActivated_few': 'Aktywowano {count} plany',
  'plans.bulkActivated_many': 'Aktywowano {count} planów',
  'plans.bulkActivated_other': 'Aktywowano {count} planu',
  'plans.bulkDeactivated_one': 'Dezaktywowano {count} plan',
  'plans.bulkDeactivated_few': 'Dezaktywowano {count} plany',
  'plans.bulkDeactivated_many': 'Dezaktywowano {count} planów',
  'plans.bulkDeactivated_other': 'Dezaktywowano {count} planu',
  'plans.deleteBulkFailed': 'Nie udało się usunąć: {message}',
  'plans.updateBulkFailed': 'Nie udało się zaktualizować: {message}',
  'plans.activated': 'Plan aktywowano',
  'plans.deactivated': 'Plan dezaktywowano',
  'plans.updateFailed': 'Nie udało się zaktualizować planu: {message}',
  'plans.deleted': 'Plan usunięto',
  'plans.deleteFailed': 'Nie udało się usunąć planu: {message}',
  'plans.actionsFor': 'Działania dla: {name}',
  'plans.activatePlan': 'Aktywuj {name}',
  'plans.deactivatePlan': 'Dezaktywuj {name}',
  'plans.onlineStore': 'Sklep internetowy',
  'plans.optional': 'Opcjonalny',
  'plans.automatic': 'Automatyczny',
  'plans.noMatch': 'Brak planów pasujących do wyszukiwania lub filtrów.',
  'plans.deleteTitle': 'Usunąć plan ochrony?',
  'plans.deleteBody': 'zostanie natychmiast usunięty z Twojego sklepu. Klienci nie zobaczą już tej opcji ochrony.',
  'plans.helpPrefix': 'Potrzebujesz pomocy? ',
  'plans.helpLink': 'Napisz do nas',
  'plans.helpSuffix': ' lub zapoznaj się z dokumentacją i samouczkami aplikacji.',

  'sort.date': 'Data (od najnowszych)',
  'sort.name': 'Nazwa (A–Z)',
  'sort.sortOrder': 'Kolejność w koszyku',
  'sort.price': 'Cena (od najniższej)',

  'planType.shipping_protection': 'Ochrona przesyłki',
  'planType.warranty': 'Gwarancja',
  'planType.return_insurance': 'Ubezpieczenie zwrotu',
  'planType.custom': 'Własna ochrona',
  'planTypeShort.shipping_protection': 'Przesyłka',
  'planTypeShort.warranty': 'Gwarancja',
  'planTypeShort.return_insurance': 'Zwrot',
  'planTypeShort.custom': 'Własny',
  'priceType.fixed': 'Stała kwota',
  'priceType.percentage': 'Procent zamówienia',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'Plan ochrony',
  'plan.loading': 'Ładowanie planu',
  'plan.notFound.heading': 'Nie znaleziono planu',
  'plan.notFound.body': 'Ten plan ochrony mógł zostać usunięty.',
  'plan.backToPlans': 'Powrót do planów',
  'plan.newTitle': 'Nowy plan ochrony',
  'plan.newSubtitle': 'Skonfiguruj ceny i wygląd w koszyku, a następnie utwórz plan',
  'plan.subtitle': 'Zmiany zostaną zastosowane w Twoim sklepie po zapisaniu',
  'plan.statusTitle': 'Stan planu',
  'plan.saveFailed': 'Nie udało się zapisać planu: {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Rodzaj ochrony',
  'form.section.basics': 'Podstawowe dane planu',
  'form.section.pricing': 'Cennik — {type}',
  'form.pricingFallback': 'Ochrona',
  'form.section.appearance': 'Wygląd',
  'form.section.fulfillment': 'Realizacja',

  'form.type.shipping_protection': 'Ochrona przesyłki',
  'form.type.shipping_protection.help': 'Chroni zamówienie klienta przed utratą, uszkodzeniem lub kradzieżą podczas wysyłki.',
  'form.type.warranty': 'Gwarancja',
  'form.type.warranty.help': 'Pokrywa wady fabryczne i normalne zużycie przez określony czas.',
  'form.type.return_insurance': 'Ubezpieczenie zwrotu',
  'form.type.return_insurance.help': 'Pozwala klientom zwracać produkty w określonym terminie z pełnym zwrotem pieniędzy.',
  'form.type.custom': 'Własna ochrona',
  'form.type.custom.help': 'Twój własny komunikat o zakresie ochrony.',

  'form.defaults.untitledPlan': 'Plan bez nazwy',
  'form.defaults.viewTerms': 'Zobacz warunki',
  'form.defaults.shipping_protection.displayName': 'Ochrona przesyłki',
  'form.defaults.shipping_protection.description': 'Chroń swoje zamówienie przed utratą, uszkodzeniem i kradzieżą podczas wysyłki.',
  'form.defaults.warranty.displayName': 'Przedłużona gwarancja',
  'form.defaults.warranty.description': 'Pokrywa wady fabryczne i normalne zużycie przez 2 lata.',
  'form.defaults.return_insurance.displayName': 'Ubezpieczenie zwrotu',
  'form.defaults.return_insurance.description': 'Zwróć dowolny produkt w ciągu 14 dni z pełnym zwrotem pieniędzy.',
  'form.defaults.custom.displayName': 'Plan ochrony',
  'form.defaults.custom.description': 'Dodaj ochronę do swojego zamówienia.',

  'form.lang.select': 'Wybierz język',
  'form.lang.default': '{name} (domyślny)',
  'form.translated': '(przetłumaczono)',

  'form.field.planName.label': 'Nazwa planu (wewnętrzna)',
  'form.field.planName.help': 'Tylko dla Twojej wiedzy — klienci nigdy jej nie widzą',
  'form.field.nameRequired': 'Nazwa wewnętrzna jest wymagana',
  'form.field.displayName.label': 'Nazwa wyświetlana',
  'form.field.displayNameRequired': 'Nazwa wyświetlana jest wymagana',
  'form.field.displayName.placeholder': 'Nazwa wyświetlana',
  'form.field.displayName.help': 'Pokazywana klientom w koszyku i przy kasie',
  'form.field.displayName.helpPreset': 'Pokazywana klientom przeglądającym w języku {lang}',
  'form.field.displayName.helpPresetFallback': 'Pokazywana klientom przeglądającym w języku {lang} — puste pola wracają do wersji {primary}',
  'form.field.description.label': 'Opis',
  'form.field.description.placeholder': 'Opis',
  'form.field.description.help': 'Krótki opis dla klientów pod nazwą planu',
  'form.field.disabledDescription.label': 'Opis odznaczenia',
  'form.field.disabledDescription.placeholder': 'Opcjonalnie — pokazywany, gdy plan nie jest zaznaczony',
  'form.field.disabledDescription.help': 'Pokazywany, gdy pole planu jest odznaczone (jeśli pusty, wraca do opisu powyżej)',
  'form.field.footer.label': 'Stopka',
  'form.field.footerText.label': 'Tekst stopki',
  'form.field.footerLink.label': 'Link stopki',
  'form.field.footerLink.help': 'Cel linku z tekstu stopki',

  'form.price.type.label': 'Rodzaj ceny',
  'form.price.fixed': 'Kwota ($)',
  'form.price.percentage': 'Procent (%)',
  'form.price.advanced': 'Ustawienie zaawansowane',
  'form.price.pctSummary': '{pct}% kwoty zamówienia, od ${min} w krokach co ${inc} do ${max} — {count} wariantów w produkcie planu',
  'form.price.tiersSummary_one': 'Produkt planu otrzymuje 1 wariant za {base} plus {count} wariant przedziałowy dla reguł wartości koszyka',
  'form.price.tiersSummary_few': 'Produkt planu otrzymuje 1 wariant za {base} plus {count} warianty przedziałowe dla reguł wartości koszyka',
  'form.price.tiersSummary_many': 'Produkt planu otrzymuje 1 wariant za {base} plus {count} wariantów przedziałowych dla reguł wartości koszyka',
  'form.price.tiersSummary_other': 'Produkt planu otrzymuje 1 wariant za {base} plus {count} wariantu przedziałowego dla reguł wartości koszyka',

  'form.validation.priceRequired': 'Wpisz wartość większą niż 0',
  'form.validation.priceMax100': 'Procent nie może przekraczać 100',
  'form.validation.warrantyYears': 'Wpisz okres od 1 do 5 lat',
  'form.validation.returnDays': 'Wpisz termin od 7 do 365 dni',
  'form.validation.maxGreaterThanMin': 'Wartość maksymalna musi być większa od minimalnej',
  'form.validation.variantIdNumeric': 'Identyfikator wariantu musi być liczbą (identyfikator ukrytego wariantu planu)',

  'form.icon.label': 'Ikona',
  'form.icon.useEmoji': 'Użyj {emoji} jako ikony planu',
  'form.icon.removeCustom': 'Usuń własną ikonę i użyj ikony tarczy',
  'form.icon.upload': 'Prześlij własny obraz ikony',
  'form.icon.uploadButton': 'Prześlij',
  'form.icon.uploading': 'Przesyłanie ikony',
  'form.icon.uploadHelp': 'Prześlij własną ikonę — PNG, JPEG, GIF lub WebP, do 5 MB.',
  'form.icon.error.notImage': 'Wybierz plik obrazu (PNG, JPEG, GIF lub WebP).',
  'form.icon.error.tooLarge': 'Obraz musi mieć 5 MB lub mniej.',

  'form.fulfillment.intro': 'Wybierz, kiedy produkt ochrony jest oznaczany jako zrealizowany.',
  'form.fulfillment.manually': 'Realizuj ręcznie',
  'form.fulfillment.first_item': 'Oznacz jako zrealizowany, gdy pierwszy produkt w zamówieniu zostanie zrealizowany',
  'form.fulfillment.all_items': 'Oznacz jako zrealizowany, gdy wszystkie pozostałe produkty w zamówieniu zostaną zrealizowane',
  'form.fulfillment.immediately': 'Oznacz jako zrealizowany bezpośrednio po utworzeniu zamówienia',

  'form.adv.title': 'Ustawienie zaawansowane',
  'form.adv.minPrice': 'Cena minimalna',
  'form.adv.minPriceHelp': 'Cena pierwszego wariantu — najniższa opłata pobierana przez plan',
  'form.adv.increment': 'Wartość przyrostu',
  'form.adv.incrementHelp': 'Krok ceny między generowanymi wariantami',
  'form.adv.maxPriceLabel': 'Cena maksymalna: ',
  'form.adv.explanation': 'Produkt planu jest generowany z {buckets} wariantami: cena minimalna {min} zajmuje jeden wariant, a pozostałe {rest} warianty rosną o {inc}, aż do ceny maksymalnej {max}. Przy kasie klient płaci pierwszy wariant o cenie równej lub wyższej niż {pct}% sumy częściowej koszyka — koszyk $100 przy 2% daje cel $2.00, więc stosuje się wariant $3.01. ',
  'form.learnMore': 'Dowiedz się więcej',

  'form.tiers.title': 'Ustaw cenę według wartości koszyka',
  'form.tiers.minCol': 'Minimalna wartość koszyka',
  'form.tiers.maxCol': 'Maksymalna wartość koszyka',
  'form.tiers.priceCol': 'Cena ochrony',
  'form.tiers.addTier': 'Dodaj nową regułę',
  'form.tiers.deleteTier': 'Usuń regułę {index}',
  'form.tiers.explanation': 'Każda reguła wymaga minimum, maksimum i ceny (reguły mogą się nakładać — stosuje się pierwsza pasująca reguła). Każda reguła staje się osobnym wariantem w produkcie planu. Jeśli suma koszyka nie pasuje do żadnej reguły, stosuje się cenę stałą z ustawienia głównego. ',
  'form.tiers.error.minRequired': 'Minimalna wartość koszyka jest wymagana',
  'form.tiers.error.maxRequired': 'Maksymalna wartość koszyka jest wymagana',
  'form.tiers.error.priceRequired': 'Cena ochrony jest wymagana',
  'form.tiers.error.pricePositive': 'Cena musi być większa niż 0',
  'form.tiers.error.minMax': 'Wartość minimalna musi być mniejsza lub równa maksymalnej',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Niezapisane zmiany',
  'savebar.discard': 'Odrzuć',
  'savebar.saving': 'Zapisywanie…',

  // ===== Preview panel =====
  'preview.title': 'Podgląd',
  'preview.simulatedSubtotal': 'Symulowana suma częściowa koszyka',
  'preview.cart': 'Koszyk',
  'preview.product': 'PRODUKT',
  'preview.total': 'RAZEM',
  'preview.subtotal': 'Suma częściowa',
  'preview.checkout': 'Do kasy',
  'preview.noPlans': 'Nie ma jeszcze aktywnych planów — klienci nie zobaczą tego widżetu.',
  'preview.autoAdded': 'Dodano automatycznie',
  'preview.unsaved': 'Nie zapisano',

  // ===== Settings page =====
  'settings.title': 'Ustawienia',
  'settings.language.title': 'Preferencje języka',
  'settings.language.help': 'Gdy odwiedzasz FlexCover, to jest język, w którym widzisz interfejs. Język Twojego sklepu nie jest zmieniany.',
  'settings.language.label': 'Język',
  'settings.language.updated': 'Zaktualizowano język',
  'settings.language.saveFailed': 'Nie udało się zapisać preferencji języka: {message}'
};

export default pl;
